
function getSpaceBetweenElements(element1, element2) {
    if (!element1 || !element2) {
        return 0;
    }
    var rect1 = element1.getBoundingClientRect();
    var rect2 = element2.getBoundingClientRect();
    return rect2.top - (rect1.top + rect1.height);
}

function calculateDistance(startSelector, endSelector) {
var startElement = document.querySelector(startSelector).parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
var endElement = document.querySelector(endSelector);

if (!startElement || !endElement) {
    console.error('Start or end element not found');
    return null;
}

// Calculate distances
var startRect = startElement.getBoundingClientRect();
var endRect = endElement.getBoundingClientRect();

// Distance from top of startElement to top of endElement
var distance = endRect.top - startRect.top;

if (window.innerHeight < 1024) {
  return distance + 310;
} else if (window.innerHeight >= 1024 && window.innerHeight < 1200) {
  return distance + 265;
} else if (window.innerHeight >= 1200 && window.innerHeight < 1440) {
  return distance + 240;
} else {
  return distance + 210;
}
// return distance + 310;
}
    


function updateSpace() {
    var start = document.querySelector('#first-content-content .about-slider-title');
    var end = document.querySelector('#third-content-content .about-slider-title');
    
    if (!start || !end) {
        return;
    }
    
    var spaceBetween = getSpaceBetweenElements(start, end);

    if (window.innerHeight < 1024) {
      var newPath = 'M 30,360 L 30,' + (spaceBetween + 380); // Set the new path length
    } else if (window.innerHeight >= 1024 && window.innerHeight < 1200) {
      var newPath = 'M 30,315 L 30,' + (spaceBetween + 335); // Set the new path length
    } else if (window.innerHeight >= 1200 && window.innerHeight < 1440) {
      var newPath = 'M 30,290 L 30,' + (spaceBetween + 310); // Set the new path length
    } else {
      var newPath = 'M 30,260 L 30,' + (spaceBetween + 280); // Set the new path length
    }
    // var newPath = 'M 30,360 L 30,' + (spaceBetween + 380); // Set the new path length

    var path = document.querySelector('.theLine');
    // console.log('New path:', newPath);
    path.setAttribute('d', newPath);


    // Update stroke-dasharray and stroke-dashoffset values based on path length
    path.style.strokeDasharray = spaceBetween + 410;
    path.style.strokeDashoffset = spaceBetween + 410;

    var halfSpaceBetween = spaceBetween * 0.5;
    var sun_start = '#first-content-content'
    var sun_end_1 = document.querySelector('#first-content-content');
    var sun_end_2 = '#second-content-content';
    var sun_end_3 = '#third-content-content';
    // console.log('calculateDistance(sun_start, sun_start):', calculateDistance(sun_start, sun_start));
    // console.log('calculateDistance(sun_start, sun_end_2):', calculateDistance(sun_start, sun_end_2));
    // console.log('calculateDistance(sun_start, sun_end_3):', calculateDistance(sun_start, sun_end_3));
    // Update transform translateY value based on spaceBetween for each pair of sun elements
    updateSunPosition('#sun_empty_1', '#sun_filled_1', calculateDistance(sun_start, sun_start), 0);
    updateSunPosition('#sun_empty_2', '#sun_filled_2', calculateDistance(sun_start, sun_end_2), 0);
    updateSunPosition('#sun_empty_3', '#sun_filled_3', calculateDistance(sun_start, sun_end_3), 0);
    // updateSunPosition('#sun_empty_1', '#sun_filled_1', 0, 240);
    // updateSunPosition('#sun_empty_2', '#sun_filled_2', halfSpaceBetween, 260);
    // updateSunPosition('#sun_empty_3', '#sun_filled_3', spaceBetween, 260);
}

function updateSunPosition(emptyId, filledId, spaceBetween, additionalOffset) {
    var sunEmpty = document.querySelector(emptyId);
    var sunFilled = document.querySelector(filledId);
    // sunEmpty.style.transform = `translateY(${spaceBetween + additionalOffset}px)`;
    // sunFilled.style.transform = `translateY(${spaceBetween + additionalOffset}px)`;
    sunEmpty.style.transform = `translateY(${spaceBetween + additionalOffset}px)`;
    sunFilled.style.transform = `translateY(${spaceBetween + additionalOffset}px)`;
}
// Update the path on load
updateSpace();

// Optionally, update the path on window resize
window.addEventListener('resize', updateSpace);



// console.clear();

// Variable to track if any content is currently being hovered
let isHovered = false;

// Check if GSAP is loaded before using it
if (typeof gsap !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
    gsap.defaults({ ease: "none" });

    // const contents = document.querySelectorAll("#first-content-content, #second-content-content, #third-content-content");
    // const contents = document.querySelectorAll(".about-slider-icon-box");
    const contents = document.querySelectorAll("#sun_filled_1, #sun_filled_2, #sun_filled_3");
    const imgIds = ["img-1", "img-2", "img-3"];

    // Hover effect
    contents.forEach((content, index) => {
        // console.log(content)

        let animation = gsap.to(content, {
            paused: true,
            scale: 1.5
        });

        content.addEventListener("mouseenter", () => {
            isHovered = true; // Set to true when content is hovered
            animation.play();
            console.log(content.id)
            if (content.id === 'sun_filled_1') {
                // if (content.id === 'first-content-content') {
                manipulateImages("first-content-content", "img-1", ["img-2", "img-3"]);
                document.getElementById("img-1").classList.add('show');
                document.getElementById("img-1").classList.remove('hide');
                ["img-2", "img-3"].forEach(imgId => {
                    const img = document.getElementById(imgId);
                    img.classList.add('hide');
                });
            } else if (content.id === 'sun_filled_2') {
                // } else if (content.id === 'second-content-content') {
                manipulateImages("second-content-content", "img-2", ["img-1", "img-3"]);
                document.getElementById("img-2").classList.add('show');
                document.getElementById("img-2").classList.remove('hide');
                ["img-1", "img-3"].forEach(imgId => {
                    const img = document.getElementById(imgId);
                    img.classList.add('hide');
                });
            } else if (content.id === 'sun_filled_3') {
                // } else if (content.id === 'third-content-content') {
                manipulateImages("third-content-content", "img-3", ["img-1", "img-2"]);
                document.getElementById("img-3").classList.add('show');
                document.getElementById("img-3").classList.remove('hide');
                ["img-1", "img-2"].forEach(imgId => {
                    const img = document.getElementById(imgId);
                    img.classList.add('hide');
                });
            }
        });

        content.addEventListener("mouseleave", () => {
            animation.reverse();
            isHovered = false; // Reset when mouse leaves content
        });
    });

// Function to calculate distance from top
function calculateDistanceFromTop(scrollElement, targetElement) {
var rectScroll = scrollElement.getBoundingClientRect();
var rectTarget = targetElement.getBoundingClientRect();
var distance = rectTarget.top - rectScroll.top;
return distance; // Return the distance between the tops of scrollElement and targetElement
}

// Function to calculate scroll time based on distance and scroll speed
function calculateScrollTime(distanceInPixels, scrollSpeedPixelsPerSecond) {
return distanceInPixels / scrollSpeedPixelsPerSecond;
}

// Example usage for first content
const scrollContainer = document.querySelector('.scroll');
const firstContent = document.querySelector('#first-content .about-slider-content');

// Calculate the distance between the top of .scroll and #first-content
const distanceFromTopFirst = calculateDistanceFromTop(scrollContainer, firstContent);
// console.log('Distance from top (First Content):', distanceFromTopFirst, 'pixels');

const scrollSpeedPixelsPerSecond = 200; // Example scroll speed in pixels per second

// Calculate the time it will take to scroll the distance for first content
const scrollTimeInSecondsFirst = calculateScrollTime(distanceFromTopFirst, scrollSpeedPixelsPerSecond);
// console.log('Scroll time (First Content):', scrollTimeInSecondsFirst.toFixed(2), 'seconds');

// Example usage for second content
const secondContent = document.querySelector('#second-content .about-slider-content');

// Calculate the distance between the top of .scroll and #second-content
const distanceFromTopSecond = calculateDistanceFromTop(scrollContainer, secondContent);
// console.log('Distance from top (Second Content):', distanceFromTopSecond, 'pixels');

// Calculate the time it will take to scroll the distance for second content
const scrollTimeInSecondsSecond = calculateScrollTime(distanceFromTopSecond, scrollSpeedPixelsPerSecond);
// console.log('Scroll time (Second Content):', scrollTimeInSecondsSecond.toFixed(2), 'seconds');

// Example usage for third content
const thirdContent = document.querySelector('#third-content .about-slider-content');

// Calculate the distance between the top of .scroll and #third-content
const distanceFromTopThird = calculateDistanceFromTop(scrollContainer, thirdContent);
// console.log('Distance from top (Third Content):', distanceFromTopThird, 'pixels');

// Calculate the time it will take to scroll the distance for third content
const scrollTimeInSecondsThird = calculateScrollTime(distanceFromTopThird, scrollSpeedPixelsPerSecond);
// console.log('Scroll time (Third Content):', scrollTimeInSecondsThird.toFixed(2), 'seconds');


let scroll1 = 0;
let scroll2 = 0;
let scroll3 = 0;

if (window.innerHeight < 1024) {
scroll1 = parseFloat(scrollTimeInSecondsFirst.toFixed(2));
scroll2 = parseFloat(scrollTimeInSecondsSecond.toFixed(2)) + 32200;
scroll3 = parseFloat(scrollTimeInSecondsThird.toFixed(2)) + 49350;
} else if (window.innerHeight >= 1024 && window.innerHeight < 1200) {
scroll1 = parseFloat(scrollTimeInSecondsFirst.toFixed(2));
scroll2 = parseFloat(scrollTimeInSecondsSecond.toFixed(2)) + 35000;
scroll3 = parseFloat(scrollTimeInSecondsThird.toFixed(2)) + 54000;
} else if (window.innerHeight >= 1200 && window.innerHeight < 1440) {
scroll1 = parseFloat(scrollTimeInSecondsFirst.toFixed(2));
scroll2 = parseFloat(scrollTimeInSecondsSecond.toFixed(2)) + 36000;
scroll3 = parseFloat(scrollTimeInSecondsThird.toFixed(2)) + 56000;
} else {
scroll1 = parseFloat(scrollTimeInSecondsFirst.toFixed(2));
scroll2 = parseFloat(scrollTimeInSecondsSecond.toFixed(2)) + 38000;
scroll3 = parseFloat(scrollTimeInSecondsThird.toFixed(2)) + 60000;
}
// const scroll1 = parseFloat(scrollTimeInSecondsFirst.toFixed(2));
// const scroll2 = parseFloat(scrollTimeInSecondsSecond.toFixed(2)) + 32200;
// const scroll3 = parseFloat(scrollTimeInSecondsThird.toFixed(2)) + 49350;

console.log('scroll1', scroll1);
console.log('scroll2', scroll2);
console.log('scroll3', scroll3);


const pulses = gsap.timeline({
    defaults: {
        duration: 0.05,
        // duration: 3000,
        autoAlpha: 1,
        transformOrigin: 'center'
    }
})
    // .to("#sun_empty_1", {}, 0)
    // .to("#sun_filled_1, #first-content-content", {}, 0.08)
    // .to("#sun_empty_2", {}, 0.40)
    // .to("#sun_filled_2, #second-content-content", {}, 0.46)
    // .to("#sun_empty_3", {}, 0.87)
    // .to("#sun_filled_3, #third-content-content", {}, 0.97);

    // Define the timeline with dynamically calculated offsets
pulses.to("#sun_empty_1", {}, scroll1 - 5000)
.to("#sun_filled_1, #first-content-content", {}, scroll1) // Adjusted offset value
.to("#sun_empty_2", {}, scroll2 - 3000) // Adjusted offset value
.to("#sun_filled_2, #second-content-content", {}, scroll2) // Adjusted offset value
.to("#sun_empty_3", {}, scroll3 - 5000) // Adjusted offset value
.to("#sun_filled_3, #third-content-content", {}, scroll3); // Adjusted offset value

var start = document.querySelector('#first-content-content .about-slider-title');
var end = document.querySelector('#third-content-content .about-slider-title');
    
if (start && end) {
    var spaceBetween = getSpaceBetweenElements(start, end);

    var strokeDashoffsetValue = (spaceBetween + 410); // Set the new path length
    var strokeDashoffsetEndValue = (parseFloat(spaceBetween) + 2700); // Set the new path length
    // console.log('strokeDashoffsetEndValue', strokeDashoffsetEndValue)

    const main = gsap.timeline({
        // defaults: { duration: 1 },
        defaults: { duration: 100000,
            ease: "power1.inOut" // Smooth easing function for scroll animation
         },
        scrollTrigger: {
            // trigger: "#svg-container",
            trigger: ".mood-science-partner-slider",
            // markers: true,
            scrub: true,
            // start: `${mspsDistanceFromTop + 485}px center`,
            start: "2000px center",
            end: `${strokeDashoffsetEndValue}px bottom`
            // start: "2000px center",
            // end: "2250px center"
            // start: "#first_section top",
            // end: "#third_section bottom"
        }
    })
        .fromTo(".theLine",
            { strokeDashoffset: strokeDashoffsetValue, opacity: 1 },
            // { strokeDashoffset: 470, opacity: 1 },
            { strokeDashoffset: 0, opacity: 1 }, 0)
        .add(pulses, 0);
    }
}

// Function to manipulate images based on content visibility
function manipulateImages(contentId, imgIdToShow, imgIdsToHide) {
    // Only execute if no content is currently being hovered
    if (!isHovered) {
        var content = document.getElementById(contentId);
        var imgToShow = document.getElementById(imgIdToShow);
        var imgsToHide = imgIdsToHide.map(id => document.getElementById(id));

        if (content.style.visibility !== "hidden") {
            imgToShow.classList.add('show');
            imgToShow.classList.remove('hide');
            imgsToHide.forEach(img => {
                img.classList.add('hide');
                img.classList.remove('show');
            });
        }
    }
}

// Function to check visibility of content elements and display img-1 if all are hidden
function checkVisibilityAndDisplay() {
    // Only execute if no content is currently being hovered
    if (!isHovered) {
        var firstContent = document.getElementById("first-content-content");
        var secondContent = document.getElementById("second-content-content");
        var thirdContent = document.getElementById("third-content-content");
        
        // Check if elements exist before calling getComputedStyle
        if (!firstContent || !secondContent || !thirdContent) {
            return;
        }
        
        const firstContentStyle = window.getComputedStyle(firstContent);
        const secondContentStyle = window.getComputedStyle(secondContent);
        const thirdContentStyle = window.getComputedStyle(thirdContent);
        const firstContentVisibility = firstContentStyle.visibility;
        const secondContentVisibility = secondContentStyle.visibility;
        const thirdContentVisibility = thirdContentStyle.visibility;
        var img1 = document.getElementById("img-1");

        if (!img1) {
            return;
        }

        const contentVisibilities = [firstContentVisibility, secondContentVisibility, thirdContentVisibility];
        if (contentVisibilities.every(visibility => visibility === "hidden" || visibility === "")) {
            img1.classList.add('show');
            img1.classList.remove('hide');
        } else {

                // Call the function for first-content-content if visibility is not "hidden"
if (firstContentVisibility !== "hidden" && firstContentVisibility !== "") {
    manipulateImages("first-content-content", "img-1", ["img-2", "img-3"]);
}

// Call the function for second-content-content if visibility is not "hidden"
if (secondContentVisibility !== "hidden" && secondContentVisibility !== "") {
    manipulateImages("second-content-content", "img-2", ["img-1", "img-3"]);
}

// Call the function for third-content-content if visibility is not "hidden"
if (thirdContentVisibility !== "hidden" && thirdContentVisibility !== "") {
    manipulateImages("third-content-content", "img-3", ["img-1", "img-2"]);
}
        }
    }
}

// Call checkVisibilityAndDisplay initially to handle initial visibility state
checkVisibilityAndDisplay();

// Create a MutationObserver to watch for changes in content visibility
var observer = new MutationObserver(checkVisibilityAndDisplay);

// Observe changes in the attributes 'style' of the content elements
const firstContentElement = document.getElementById("first-content-content");
const secondContentElement = document.getElementById("second-content-content");
const thirdContentElement = document.getElementById("third-content-content");

if (firstContentElement) {
    observer.observe(firstContentElement, { attributes: true });
}
if (secondContentElement) {
    observer.observe(secondContentElement, { attributes: true });
}
if (thirdContentElement) {
    observer.observe(thirdContentElement, { attributes: true });
}